import * as angular from "angular";
import {IController} from "angular";
import {TagModel} from "../../angular/models/tag.model";
import {ConfirmDialogService} from "../../../commons/services/confirm-dialog.service";
import {TagsDialogService} from "../../services/tags-dialog.service";
import {TagsService} from "../../services/tags-service.service";
import {TagType} from "../../angular/types/tag.type";

export class TagsViewComponent implements IController {

  public tagsRef: any;
  public infiniteScroll;
  public loadLimit: number;
  public searchQuery: string;
  public tagType: TagType = TagType.Info;

  constructor(private $tags, private $log, private $infiniteScroll, private confirmDialogService: ConfirmDialogService,
              private tagsDialogService: TagsDialogService, private tagsService: TagsService) {
  }

  $onInit() {
    this.tagsRef = this.$tags();
    this.loadLimit = 20;

    this.tagsRef.$query(this.getQuery());
    this.infiniteScroll = this.$infiniteScroll(this.tagsRef, this.loadLimit, {getFullData: true});
  }

  submitQuery(queryString: string) {
    this.searchQuery = queryString;
    this.reloadQuery();
  }

  onTabChanged(type) {
    this.tagType = type;
    this.reloadQuery();
  }

  onCreateTag(event) {
    this.tagsDialogService.onCreateTag(this.tagType, this.tagType === TagType.Info, event)
      .then((tag: TagModel) => {
        this.createTag(tag);
      });
  }

  onEditTag(tag: TagModel, event) {
    const tagCopy = {...tag};

    this.tagsDialogService.onEditTag(tagCopy, event)
      .then((tag: TagModel) => {
        this.editTag(tag);
      });
  }

  onDeleteTag(tag: TagModel, event) {
    const tagCopy = {...tag};
    this.confirmDialogService.confirm('Delete Tag', 'Are you sure you want to delete this tag?', event)
      .then(() => {
        tagCopy.active = false;
        this.deleteTag(tagCopy);
      })
  }

  /******************
   * agent tag actions:
   * ****************/

  // onCreateAgentTag(type, event) {
  //   this.tagsDialogService.onCreateAgentTag(type, event)
  //     .then((agentTag: TagModel) => {
  //       this.createTag(agentTag);
  //     });
  // }
  //
  // onDeleteAgentTag(tag: TagModel, event) {
  //   const tagCopy = {...tag};
  //   this.confirmDialogService.confirm('Delete Tag', 'Are you sure you want to delete this tag?', event)
  //     .then(() => {
  //       tagCopy.active = false;
  //       this.deleteTag(tagCopy);
  //     })
  // }

  /******************
   * private methods:
   * ****************/

  private createTag(tag: TagModel) {
    this.tagsService.createTag(tag)
      .then(() => this.reloadQuery());
  }

  private editTag(tag: TagModel) {
    this.tagsService.editTag(tag)
      .then(() => this.reloadQuery());
  }

  private deleteTag(tag: TagModel) {
    this.tagsService.deleteTag(tag)
      .then(() => this.reloadQuery());
  }

  private reloadQuery() {
    this.tagsRef.$query(this.getQuery())
      .then(() => {
        this.infiniteScroll.reload();
      })
      .catch((error) => {
        this.$log.error('Fail to $query', error);
      })
  }

  private getQuery() {
    return {
      limit: this.loadLimit,
      query: this.searchQuery,
      type: this.tagType
    }
  }

}

angular
  .module('bringoz.admin.tags')
  .component('tagsView', {
    bindings: {},
    template: require('./tags-view.html').default,
    controller: TagsViewComponent
  });
